var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFarmsLight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.4942 9.95989C16.494 9.95941 16.4938 9.95892 16.4935 9.95844L16.4942 9.95989ZM11.9978 7.62265L16.6056 10.209L18.2535 13.8929V19.7255H5.74561V13.8926L7.39025 10.2088L11.9978 7.62265ZM18.2535 13.7088V13.7191C18.2535 13.7157 18.2535 13.7122 18.2535 13.7088L18.2535 13.7088Z",
    stroke: "currentColor",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 2.85C12.1445 2.85 12.2868 2.88617 12.4137 2.95522L12 2.85ZM12 2.85C11.8554 2.85 11.7131 2.8862 11.5861 2.9553M12 2.85L11.5861 2.9553M11.5861 2.9553L4.6524 6.7194C4.48856 6.80812 4.35784 6.94736 4.27988 7.11639L11.5861 2.9553ZM22.1361 12.3396L19.7202 7.11657H4.27979L1.86386 12.3396L1.80073 12.4761L1.93736 12.5388L3.23727 13.1363L3.37329 13.1988L3.43608 13.0629L5.72953 8.09913L11.9969 4.69446L18.2652 8.09917L20.564 13.063L20.6268 13.1988L20.7627 13.1363L22.0626 12.5388L22.1993 12.4761L22.1361 12.3396ZM19.7201 7.11639C19.6422 6.94736 19.5114 6.80812 19.3476 6.7194L12.4139 2.9553L19.7201 7.11639Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.3
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFarmsLight);
export default __webpack_public_path__ + "static/media/farmsLight.5b3e168695476e34ae539084d5f29f60.svg";
export { ForwardRef as ReactComponent };